/* eslint-disable global-require */

module.exports = ['indexes._advanced.m1', 'artprice.mystore.default.m21', 'indexes._second_chart.m6'];
